module.exports = __webpack_public_path__ + "img/dog-groom.655bb090.png";